const config = {
  url: process.env.REACT_APP_FEATURE_FLAG_API_URL,
  clientKey: process.env.REACT_APP_FEATURE_FLAG_CLIENT_KEY,
  appName: process.env.REACT_APP_FEATURE_FLAG_APP_NAME,
  refreshInterval: process.env.REACT_APP_FEATURE_FLAG_REFRESH_INTERVAL,
};

export default config;
